module.exports = __webpack_public_path__ + "img/11_53.b622ab7d.png";